import { render, staticRenderFns } from "./PartnerUserAdd.vue?vue&type=template&id=f997b6a6&scoped=true"
import script from "./PartnerUserAdd.vue?vue&type=script&lang=ts"
export * from "./PartnerUserAdd.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f997b6a6",
  null
  
)

export default component.exports